import Paperdoll from "../screen/containers/paperdoll/Paperdoll.js";
import Helper from "../utils/helper/Helper.js";
import ItemProviders from "./ItemProviders.js";

export default class Comparer {
	static compare(paperdoll, o) {
		//console.log(paperdoll);
		//console.log(o);
		

		let item = o.item;
		if (paperdoll.hasItem(item)) {
			return
		}
		let toCompare = new Array();
		let a = Paperdoll.SLOTS;
		let slots = paperdoll.getItemsSlots();
		for (let x = 0; x < 10; x++) {
			let tmp = a[x].accept;
			if (tmp.indexOf(item.type) >= 0) {
				toCompare.push(slots[x]);
			}
		}

		Comparer.compareSlot(toCompare, o);
	}

	static compareSlot(slots, o) {
		//console.log(slot)
		let itemWorn
		let item = o.item;
		if (item.isWeapon()) {
			let toCompare = new Array();
			for (let x = 0; x < slots.length; x++) {
				itemWorn = slots[x].getItem();
				if (!itemWorn) {
					itemWorn = {
						attack_max: 0,
						attack_min: 0,
						speed: 0,
						bonus_skill: 0,
						player_skill: ItemProviders.PLAYER_SKILL_NONE
					}
				}
				toCompare.push(itemWorn);
			}
			Comparer.compareWeapon(item, toCompare, o)

		} else if (item.isArmour()) {
			let toCompare = new Array();
			for (let x = 0; x < slots.length; x++) {
				itemWorn = slots[x].getItem();

				if (!itemWorn) {
					itemWorn = {
						defense: 0,
						speed: 0,
						bonus_skill: 0,
						player_skill: ItemProviders.PLAYER_SKILL_NONE
					}
				}
				toCompare.push(itemWorn);
			}
			Comparer.compareArmour(item, toCompare, o)

		} else if (item.isJewel()) {
			let toCompare = new Array();
			for (let x = 0; x < slots.length; x++) {
				itemWorn = slots[x].getItem();

				if (!itemWorn) {
					itemWorn = {
						bonus_damage: 0,
						bonus_defense: 0,
						bonus_speed: 0,
						bonus_skill: 0,
						player_skill: ItemProviders.PLAYER_SKILL_NONE
					}

				}
				toCompare.push(itemWorn);
			}

			Comparer.compareJewel(item, toCompare, o)

		}

	}


	static compareWeapon(item, itemWorns, o) {
		let ref;
		let diff;
		let itemWorn = itemWorns[0];

		ref = jQuery(".js-attack-min", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = Comparer.markGreenOrRed(item.attack_min - itemWorn.attack_min);
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())

		ref = jQuery(".js-attack-max", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = Comparer.markGreenOrRed(item.attack_max - itemWorn.attack_max);
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())

		ref = jQuery(".js-speed", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = Comparer.markGreenOrRed(item.speed - itemWorn.speed);
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())


		//let difAttackMax = item.attack_max - itemWorn.attack_max;

	}
	static compareArmour(item, itemWorns, o) {
		let ref;
		let diff;
		let itemWorn = itemWorns[0];

		ref = jQuery(".js-defense", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = Comparer.markGreenOrRed(item.defense - itemWorn.defense);
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())

		ref = jQuery(".js-speed", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = Comparer.markGreenOrRed(item.speed - itemWorn.speed);
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())

	}
	static compareJewel(item, itemWorns, o) {
		let ref;
		let diff;
		ref = jQuery(".js-bonus-damage", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = "";
		for (let x = 0; x < itemWorns.length; x++) {
			let itemWorn = itemWorns[x];
			diff += Comparer.markGreenOrRed(item.bonus_damage - itemWorn.bonus_damage, true, ((x == 0) && (itemWorns.length > 1)) ? false : true);
		}
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())

		ref = jQuery(".js-bonus-defense", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = "";
		for (let x = 0; x < itemWorns.length; x++) {
			let itemWorn = itemWorns[x];
			diff += Comparer.markGreenOrRed(item.bonus_defense - itemWorn.bonus_defense, true, ((x == 0) && (itemWorns.length > 1)) ? false : true);
		}
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())

		ref = jQuery(".js-bonus-speed", o.win.clipContent)
		jQuery(".js-cmp", ref).show();
		diff = "";
		for (let x = 0; x < itemWorns.length; x++) {
			let itemWorn = itemWorns[x];
			diff += Comparer.markGreenOrRed(item.bonus_speed - itemWorn.bonus_speed, true, ((x == 0) && (itemWorns.length > 1)) ? false : true);
		}
		jQuery(".js-cmp", ref).html(diff + jQuery(".js-dx", ref).text())


	}

	static markGreenOrRed(value, perc = false, space = true) {
		let s = "" + value;
		if (perc) {
			s = Helper.toFloat(s);
		}
		if (value < 0) {
			s = "<span class='text-red text-smaller'>(" + s + ")</span>";
			return s + (space ? " " : "");
		}
		if (value > 0) {
			s = "<span class='text-green text-smaller'>(+" + s + ")</span>";
			return s + (space ? " " : "")
		}
		return "";
	}

}